/* eslint-disable */
// src/utils/formatters.js

// Cuenta cuántos decimales trae el valor recibido (string o number).
// Nota: si viene como number, los ceros a la derecha no existen en JS
// (p.ej. 1.230 -> 1.23). Si te llegan como string, sí se conservarían.
const fractionDigitsOf = (value) => {
  if (value == null) return 0;
  const s = typeof value === "string" ? value : String(value);
  // Normaliza coma a punto por si llega "123,45"
  const normalized = s.replace(",", ".");
  const m = normalized.match(/^-?\d+(?:\.(\d+))?$/);
  return m && m[1] ? m[1].length : 0;
};

// Limita a algo razonable para evitar formatos con miles de decimales
const cap = (n, max = 2) => (n > max ? max : n);
const toFiniteNumber = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};
const formatNumberEsUy = (value, options = {}) =>
  new Intl.NumberFormat("es-UY", options).format(Number(value ?? 0));
const withPesoSymbol = (formattedNumber) => `$ ${formattedNumber}`;

// Truncado hacia cero para visualizacion.
// Ejemplos: 17.4 -> 17, 17.5 -> 17, 17.6 -> 17, 17.9 -> 17
// Para negativos tambien acerca a cero:
// -1.1 -> -1, -1.9 -> -1
export const roundForDisplay = (value) => {
  const n = toFiniteNumber(value, 0);
  return Math.trunc(n);
};


// ======== Formateadores existentes (no los toco) ========
// Los dejo como ya los tenías definidos en tu proyecto.
// (Si acá tenías otra configuración, mantenela igual.)
export const nf       = new Intl.NumberFormat("es-UY");
export const moneyFmt = {
  format(value) {
    return withPesoSymbol(formatNumberEsUy(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  },
};
export const moneyFmt0 = {
  format(value) {
    return withPesoSymbol(formatNumberEsUy(value, { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
  },
};


// ======== formateadores DINÁMICOS (drop-in) ========
// Tienen una API compatible con Intl: objeto con método .format(valor)
// para que no tengas que cambiar la forma en que los llamás.

export const nfDynamic = {
  format(value) {
    const digits = cap(fractionDigitsOf(value));
    return formatNumberEsUy(value, {
      minimumFractionDigits: 0,  // si es entero, no muestra decimales
      maximumFractionDigits: digits, // si tiene decimales, muestra exactamente esos (hasta 20)
    });
  },
};

export const moneyFmtDynamic = {
  format(value) {
    const digits = cap(fractionDigitsOf(value));
    return withPesoSymbol(formatNumberEsUy(value, {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
    }));
  },
};

// ======== formateadores DINAMICOS con redondeo entero ========
// Para capa de presentación en recaudaciones:
// mantienen decimales en datos/cálculo, pero visualizan enteros redondeados.
export const nfRoundedDynamic = {
  format(value) {
    const rounded = roundForDisplay(value);
    return formatNumberEsUy(rounded, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  },
};

export const moneyFmtRoundedDynamic = {
  format(value) {
    const rounded = roundForDisplay(value);
    return withPesoSymbol(formatNumberEsUy(rounded, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }));
  },
};
